import React, { Fragment, useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FoodIcon from '@material-ui/icons/EmojiFoodBeverageOutlined';
import ExploreIcon from '@material-ui/icons/ExploreOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import LocationIcon from '@material-ui/icons/LocationOnOutlined';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { _T } from 'appI18n';
import { LightboxThumbnail } from './LightboxThumbnail';
import Cost from '../../../../include/react-components/Cost';
import { Button, Divider } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useTourDescription, useTourExtras, useTourVariant } from '../../store/TourDescriptionStore';
import moment from 'moment';
import { _ParentFrame } from '../../../Frame/types/Frame';
const useStyles = makeStyles(theme => ({
    root: {
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    feature: {
        borderRadius: theme.shape.borderRadius,
        display: 'flex',
        padding: '2px 8px',
        border: '1px solid #dadada',
        marginBottom: '2px',
        marginRight: '2px',
    },
    featureIcon: {
        display: 'flex',
        marginRight: theme.spacing(1),
        alignItems: 'center',
        color: '#555',
    },
    featureTitle: {
        color: '#555',
        textShadow: '0.15px 0 #555',
    },
    transportContainer: {},
    currentTransport: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0 8px',
        marginLeft: 4,
        color: theme.palette.success.main,
        '& > :last-child': { marginRight: theme.spacing(.5) }
    },
}));
function ExcursionFeature({ icon, title, value }) {
    const classes = useStyles();
    if (!value)
        return null;
    return (React.createElement("div", { className: classes.feature },
        React.createElement("div", { className: classes.featureIcon }, icon),
        React.createElement(Box, null,
            React.createElement(Typography, { variant: "caption", component: "h6", className: classes.featureTitle }, title),
            React.createElement(Typography, { variant: "body1" }, value))));
}
export default function ExcursionDescription({ service: excursion, isFrame }) {
    const classes = useStyles();
    const images = useMemo(() => {
        return excursion.excursionDescription.excursionImages.map(x => ({
            urls: { thumbnail: x.url, large: x.url, original: x.url },
            description: x.description
        }));
    }, [excursion.id]);
    const [{ tourVariant, currentAccommodationVariants, totalVariantPrice }, actions] = useTourVariant(isFrame);
    const [{ extras, price }] = useTourExtras(isFrame);
    const [{ excursionServices, hotelServices, externalFlight, hash }] = useTourDescription(null, isFrame);
    const excursionServicesString = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}__${e.beginDate}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "", [excursionServices]);
    const excursionsPrice = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 1 ? excursionServices.filter(s => s != excursion).map(s => { var _a, _b, _c, _d, _e, _f, _g; return ((_b = (_a = s.excursionPrice) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0) - ((_g = (_f = ((_d = (_c = s.prices) === null || _c === void 0 ? void 0 : _c.find(p => p.vehicleTypeId == excursion.vehicleTypeId)) !== null && _d !== void 0 ? _d : (_e = s.prices) === null || _e === void 0 ? void 0 : _e.find(p => p.vehicleTypeId == 0))) === null || _f === void 0 ? void 0 : _f.price) !== null && _g !== void 0 ? _g : 0); }).reduce((a, b) => a + b) : 0, [excursionServices]);
    const sortedPrices = useMemo(() => (excursion.prices || []).sort((a, b) => a.price - b.price), [excursion.prices, currentAccommodationVariants, tourVariant]);
    const showTransport = sortedPrices.length > 1 || (sortedPrices.length == 1 && sortedPrices[0].vehicleTypeName != null && sortedPrices[0].vehicleTypeName != undefined);
    const handleTransportChanged = (price) => actions.setExcursionTransport(excursion.id, price === null || price === void 0 ? void 0 : price.vehicleTypeId);
    const fullPrice = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let cost = actions.getTourCost();
        let originalServiceCost = (_a = excursion.excursionPrice) === null || _a === void 0 ? void 0 : _a.costEntityWithPromo;
        //let originalServiceCost = price?.services.find(s => s.compositeId == excursion.compositeId)?.costEntityWithPromo;
        //let p = 0;
        //p -= (sortedPrices.find(sp => sp.vehicleTypeId == excursion.vehicleTypeId)?.price ?? 0);
        //p += excursionsPrice;
        return {
            brutto: cost.brutto - ((_b = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _b !== void 0 ? _b : 0),
            netto: cost.netto,
            discount: cost.discount,
            total: cost.brutto + cost.discount - ((_c = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _c !== void 0 ? _c : 0),
            roundBrutto: Math.ceil(cost.brutto - ((_d = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _d !== void 0 ? _d : 0)),
            roundTotal: Math.ceil(cost.brutto + cost.discount - (((_e = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _e !== void 0 ? _e : 0) + ((_f = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.discount) !== null && _f !== void 0 ? _f : 0))),
            roundDiscount: Math.ceil(cost.brutto + cost.discount - ((_g = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _g !== void 0 ? _g : 0)) - Math.ceil(cost.brutto - ((_h = originalServiceCost === null || originalServiceCost === void 0 ? void 0 : originalServiceCost.brutto) !== null && _h !== void 0 ? _h : 0)),
        };
    }, [extras, price === null || price === void 0 ? void 0 : price.services, price === null || price === void 0 ? void 0 : price.defaultAirServices, externalFlight, excursionServicesString]);
    //const fullPrice = useMemo(() => {
    //    if (!tourVariant)
    //        return 0;
    //    let p = totalVariantPrice + (externalFlight?.flightCostDifference ?? 0)
    //    //let p = tourVariant.price;
    //    //p += currentAccommodationVariants.map(hs => hs.accommodation?.price ?? 0).reduce((a, b) => a + b);
    //    p -= (sortedPrices.find(sp => sp.vehicleTypeId == excursion.vehicleTypeId)?.price ?? 0);
    //    p += excursionsPrice;
    //    if (price)
    //        p += Object.keys(extras).map(e => getExtraCost(e, extras, price, tourVariant)).reduce((c, p) => c + p, 0);
    //    //let extraKeys = Object.keys(extras);
    //    //p += price.extras.filter(e => extraKeys.find(k => e.id == key) && ex)
    //    //p += price!.extras.filter(e => extras[getExtraKey(e)]?.length).map(e => e.cost * (e.isGroupCost ? 1 : extras[getExtraKey(e)]!.length)).reduce((c, p) => c + p, 0);
    //    return p;
    //}, [tourVariant?.price, currentAccommodationVariants, excursion, excursionsPrice, externalFlight?.flightCostDifference, extras, hash]);
    return React.createElement(Paper, { className: classes.root, elevation: 0 },
        React.createElement(Typography, { variant: "h6" },
            excursion.name,
            " ",
            moment(excursion.beginDate).format("L"),
            " (",
            moment(excursion.beginDate).format("dd"),
            ")"),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, container: true, spacing: 1 },
                React.createElement(Grid, { item: true, xs: 8 },
                    React.createElement(LightboxThumbnail, { images: images, height: 240, onImageClick: isFrame ? () => {
                            const parentFrame = _ParentFrame();
                            parentFrame.sendMessage({ message: 'open-gallery', params: {} });
                        } : undefined })),
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(Box, { display: "flex", flexWrap: "nowrap", mt: 0, flexDirection: "column" },
                        React.createElement(ExcursionFeature, { icon: React.createElement(InfoIcon, null), title: _T.EXCURSION_TYPE, value: excursion.excursionDescription.excursionTypeName }),
                        React.createElement(ExcursionFeature, { icon: React.createElement(ScheduleIcon, null), title: _T.COMMON_DURATION, value: excursion.excursionDescription.excursionDuration }),
                        React.createElement(ExcursionFeature, { icon: React.createElement(ExploreIcon, null), title: _T.COMMON_DIRECTION, value: `${excursion.city.name}, ${excursion.city.country.name}` }),
                        React.createElement(ExcursionFeature, { icon: React.createElement(FoodIcon, null), title: _T.EXCURSION_MEAL, value: excursion.excursionDescription.mealDescription }),
                        React.createElement(ExcursionFeature, { icon: React.createElement(LocationIcon, null), title: _T.COMMON_MEET_POINT, value: excursion.excursionDescription.rootPoint })))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "body1" },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: excursion.excursionDescription.mainDescription } }))),
            React.createElement(Grid, { item: true, xs: 12 }, tourVariant && showTransport &&
                React.createElement(Paper, { className: classes.transportContainer, elevation: 0, variant: "outlined" },
                    React.createElement(Box, { p: 2 },
                        React.createElement(Typography, { variant: "subtitle1", gutterBottom: true }, _T.EXCURSION_AVAILABLE_TRANSPORT_TYPES),
                        React.createElement(Box, { mt: 3 }, sortedPrices.map((x, i) => {
                            var _a, _b;
                            const isCurrentVariant = excursion.currentVehicleTypeId == x.vehicleTypeId;
                            return React.createElement(Fragment, { key: `${x.id}-${x.vehicleTypeId}` },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, sm: 8 }, x.vehicleTypeName || null),
                                    React.createElement(Grid, { item: true, xs: 2 },
                                        React.createElement(Cost, { amount: fullPrice.roundTotal + x.price, currency: (_b = (_a = x.currency) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '', amountVariant: "h6" })),
                                    React.createElement(Grid, { item: true, xs: 2 }, !isCurrentVariant
                                        ? React.createElement(Button, { color: "secondary", variant: "outlined", fullWidth: true, onClick: handleTransportChanged.bind(null, x) },
                                            _T.COMMON_CHOOSE,
                                            " ",
                                            React.createElement(ChevronRightIcon, null))
                                        : React.createElement(Typography, { className: classes.currentTransport, variant: "button", component: "div" },
                                            React.createElement(CheckIcon, null),
                                            " ",
                                            _T.TOUR_SELECTED))),
                                sortedPrices.length - 1 > i && React.createElement(Box, { my: 1 },
                                    React.createElement(Divider, null)) || null);
                        })))))));
}
